import React from 'react';
import { Container } from 'react-bootstrap';
import { styled } from 'baseui';

import IconRadio from 'presentation/components/IconRadio';
import { TrackerUtil } from 'tracking/TrackerUtil';
import { RadioGroup } from 'baseui/radio';

interface Props {
  radioData: {
    icon: string;
    label: string;
    optionKey: string;
    trackingId: string;
  }[];
  handleChange: (newVal: string) => void;
  currentSelection: () => string;
}

const ResponsiveFlexDirectionContainer = styled('div', {
  '@media (max-width: 767px)': {
    flexDirection: 'column'
  }
});

const IconRadioGroup: React.FC<Props> = ({
  radioData,
  handleChange,
  currentSelection,
  children
}) => {
  return (
    <RadioGroup>
      <>
        <Container>
          <ResponsiveFlexDirectionContainer tabIndex={-1} className="d-flex">
            {radioData.map((item: any, index: number) => {
              return (
                <IconRadio
                  key={index}
                  mainIconSrc={item.icon}
                  iconMaxSize={item.iconMaxSize}
                  optionTitle={item.label}
                  radioValue={item.optionKey}
                  wasSelected={(newVal: string) => {
                    TrackerUtil.trackRadioClick(
                      `${TrackerUtil.getPageName()}_${item.trackingId}`,
                      item.trackingId
                    );
                    handleChange(newVal);
                  }}
                  isChecked={currentSelection() === item.optionKey}
                  additionalTestId={item.optionKey}
                />
              );
            })}
          </ResponsiveFlexDirectionContainer>
        </Container>
      </>
      ,
    </RadioGroup>
  );
};
export default IconRadioGroup;
